var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscriptions" },
    [
      _vm.subscription
        ? _c(
            "subscription-edit",
            _vm._b(
              {},
              "subscription-edit",
              { subscription: _vm.subscription },
              false
            )
          )
        : _c("div", [
            _c("h2", { staticClass: "title" }, [_vm._v("Upcoming Orders")]),
            _vm.subscriptions === null
              ? _c("div", [_vm._v("Loading...")])
              : _vm.subscriptions.length === 0
              ? _c("div", [_vm._v("No subscriptions!")])
              : _c(
                  "div",
                  _vm._l(_vm.subscriptions, function(subscription_item) {
                    return _c(
                      "div",
                      [
                        _c(
                          "subscription",
                          _vm._b(
                            {},
                            "subscription",
                            { subscription: subscription_item, buttons: true },
                            false
                          )
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }